export default "__VITE_ASSET__CnMLCD2J__"